import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function CGU() {
  return (
    <div className="min-h-screen bg-[#0D0D0D] text-white">
      <div className="max-w-3xl mx-auto px-6 py-20">
        <Link
          to="/"
          data-testid="cgu-back-link"
          className="inline-flex items-center gap-2 text-[#A0A0A0] hover:text-[#FF6B35] text-sm mb-8 transition-colors"
        >
          <ArrowLeft size={16} />
          Retour à l'accueil
        </Link>

        <h1 className="font-['Poppins'] font-bold text-3xl sm:text-4xl mb-8">
          Conditions Générales d'Utilisation
        </h1>
        <p className="text-[#A0A0A0] text-xs mb-8">Dernière mise à jour : Janvier 2026</p>

        <div className="space-y-8 text-[#A0A0A0] text-sm leading-relaxed">
          <section>
            <h2 className="text-white font-['Poppins'] font-semibold text-lg mb-3">1. Objet</h2>
            <p>
              Les présentes Conditions Générales d'Utilisation (CGU) régissent l'utilisation de l'application mobile ClayPulse et du site web associé. En utilisant nos services, vous acceptez ces conditions dans leur intégralité.
            </p>
          </section>

          <section>
            <h2 className="text-white font-['Poppins'] font-semibold text-lg mb-3">2. Description du service</h2>
            <p>
              ClayPulse est une application de suivi de performance pour les tireurs de ball-trap. Elle permet l'enregistrement des scores, l'analyse des performances, le suivi météorologique et la gestion de l'équipement.
            </p>
          </section>

          <section>
            <h2 className="text-white font-['Poppins'] font-semibold text-lg mb-3">3. Inscription et compte</h2>
            <p>
              L'utilisation de ClayPulse nécessite la création d'un compte. Vous êtes responsable de la confidentialité de vos identifiants de connexion. Vous devez fournir des informations exactes et à jour.
            </p>
          </section>

          <section>
            <h2 className="text-white font-['Poppins'] font-semibold text-lg mb-3">4. Abonnement et paiement</h2>
            <p>
              ClayPulse propose un essai gratuit de 7 jours. À l'issue de l'essai, un abonnement mensuel (6,99 €/mois) ou annuel (67 €/an) est requis. Les paiements iOS transitent par l'App Store, les paiements Android par Stripe. L'annulation est possible à tout moment.
            </p>
          </section>

          <section>
            <h2 className="text-white font-['Poppins'] font-semibold text-lg mb-3">5. Propriété intellectuelle</h2>
            <p>
              L'ensemble du contenu de ClayPulse (textes, graphiques, logos, icônes, images, logiciels) est la propriété exclusive de ClayPulse et est protégé par les lois sur la propriété intellectuelle.
            </p>
          </section>

          <section>
            <h2 className="text-white font-['Poppins'] font-semibold text-lg mb-3">6. Responsabilité</h2>
            <p>
              ClayPulse met tout en œuvre pour assurer la disponibilité et la fiabilité du service. Cependant, nous ne garantissons pas un fonctionnement ininterrompu. ClayPulse ne saurait être tenu responsable des dommages indirects liés à l'utilisation du service.
            </p>
          </section>

          <section>
            <h2 className="text-white font-['Poppins'] font-semibold text-lg mb-3">7. Modification des CGU</h2>
            <p>
              ClayPulse se réserve le droit de modifier les présentes CGU à tout moment. Les utilisateurs seront informés de toute modification par notification dans l'application.
            </p>
          </section>

          <section>
            <h2 className="text-white font-['Poppins'] font-semibold text-lg mb-3">8. Contact</h2>
            <p>
              Pour toute question relative aux présentes CGU, veuillez contacter :{' '}
              <a href="mailto:supportclaypulse@gmail.com" className="text-[#FF6B35] hover:underline">
                supportclaypulse@gmail.com
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
